import { Site } from "@/types/sites";
import OneSignal from 'react-onesignal';
import {useEffect} from 'react';

export const OneSignalWrapper = ({ site, hasOfferList }: { site: Site | null, hasOfferList: boolean }) => {
    const oneSignalId = site?.attributes?.third_party_scripts?.OneSignalAccountId;
    useEffect(() => {
      if (oneSignalId) {
          OneSignal.init({
              appId: oneSignalId,
              allowLocalhostAsSecureOrigin: true,
              notifyButton: {
                  enable: hasOfferList,
                  displayPredicate: () => hasOfferList,
              },
              promptOptions: {
                  slidedown: {
                    prompts: [
                      {
                        type: 'push',
                        autoPrompt: hasOfferList,
                        delay: { timeDelay: 3 },
                        text: {
                          actionMessage: "Subscribe to our notifications for the latest news and updates. You can disable at any time.",
                          acceptButton: "Subscribe",
                          cancelButton: "Later"
                        }
                      }
                    ]
                  },
              }
          })
      }
  }, [oneSignalId, hasOfferList]);

  return null;
};
